const invokes = {}
let invokeId = 1;
const listenObj = {};
window.listenObj = listenObj;

function removeInvoke(invoke) {
  window[invoke.callback] = null;
  if(invoke.iframe){
    document.body.removeChild(invoke.iframe);
  }
  delete invokes[invoke.callback];
  delete window[invoke.callback];
}

function invokeNative(func, params, onSuccess, onError) {
  const invoke = {
    func: func,
    callback: "uniwebToNativeCallback" + invokeId,
    params: params
  };
  const iframe = document.createElement("iframe");
  iframe.src = "uniweb://" + encodeURIComponent(JSON.stringify(invoke));
  iframe.className = "native-iframe";
  iframe.style.display = 'none';
  invoke.iframe = iframe;
  invokes[invoke.callback] = invoke;
  window[invoke.callback] = function (res) {
    if (res && res.errno) {
      console.log(res);
      onError && onError(res);
    } else {
      onSuccess && onSuccess(res);
    }
    removeInvoke(invoke);
  };
  setTimeout(() => {
    // document.body.removeChild(invoke.iframe);
    // removeInvoke(invoke);
    invoke.iframe = null;
  }, 10000);
  document.body.appendChild(iframe);
  invokeId++;
}

window['nativeToUniwebEmit'] = function(eventName,res){
  if(listenObj[eventName]){
    for(let func of listenObj[eventName]){
      try{
        typeof func == 'function' && func(res);
      }catch(e){};
    }
  }
}

export function listen(eventName,func){
  listenObj[eventName] = listenObj[eventName] || [];
  listenObj[eventName].push(func);
}
export function unlisten(eventName,func){
  if(listenObj[eventName] && func){
    let index = listenObj[eventName].indexOf(func);
    listenObj[eventName].splice(index,1);
    return;
  }else if(listenObj[eventName] && eventName){
    listenObj[eventName].length = 0;
  }
}

export function playGameMusic(){
  invokeNative('playGameMusic')
}

export function stopGameMusic(){
  invokeNative('stopGameMusic')
}


export default invokeNative;
